import { createStore } from 'vuex'

var URL = 'https://server-web.konaweselatankab.go.id/';
var URLS = 'https://dpmd.konaweselatankab.go.id/';

var UNIT = 'jsEKJpJKfirTXCw8A';

export default createStore({
  state: {
    UNIT_KERJA : UNIT,
    url : {
      URL : URLS,
      URL_APP : URL,
      URL_SLIDER : URL + 'api/v1/publish_dpmd_slider/',
      URL_SAMBUTAN : URL + 'api/v1/publish_dpmd_sambutan/',
      URL_BERITA : URL + 'api/v1/web_publish_berita/',
      URL_FOTO : URL + 'api/v1/publish_dpmd_foto/',
      URL_VIDEO : URL + 'api/v1/publish_dpmd_video/',
      URL_PROFIL : URL + 'api/v1/publish_dpmd_tentang/',
      URL_VISI : URL + 'api/v1/publish_dpmd_visi_misi/',
      URL_STRUKTUR : URL + 'api/v1/publish_dpmd_struktur_organisasi/',
      URL_TUPOKSI : URL + 'api/v1/publish_dpmd_tupoksi/',
      URL_LINK : URL + 'api/v1/web_publish_link_terkait/',
      URL_PEJABAT : URL + 'api/v1/publish_dpmd_profil_pejabat/',
      URL_BERITA : URL + 'api/v1/web_publish_berita/',
      URL_PENGUMUMAN : URL + 'api/v1/publish_dpmd_pengumuman/',
      URL_UNIT_KERJA : URL + 'api/v1/publish_dpmd_bidang/',
      URL_LAYANAN : URL + 'api/v1/publish_dpmd_layanan/',
      URL_DATA : URL + 'api/v1/publish_dpmd_data/',
      URL_DOKUMEN : URL + 'api/v1/publish_dpmd_dokumen/',
      URL_PRODUK_HUKUM : URL + 'api/v1/publish_dpmd_produk_hukum/',
      URL_FOTO : URL + 'api/v1/publish_dpmd_foto/',
      URL_VIDEO : URL + 'api/v1/publish_dpmd_video/',
    }
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
